






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Interceptor extends Vue {
	@Prop({ type: Number, required: false, default: 0 }) margin!: number;

	observer: IntersectionObserver | null = null;

	observe(): void {
	    const options: IntersectionObserverInit = { rootMargin: `${this.margin}px`, threshold: 1.0 };
	    this.observer = new IntersectionObserver(entries => {
	        entries.forEach(entry => {
	            if (entry.isIntersecting) {
	                this.$emit('visible');
	            } else {
	                this.$emit('hidden');
	            }
	        });
	    }, options);
	    this.observer.observe(this.$el);
	}

	unObserve(): void {
	    if (this.observer) {
	        this.observer.unobserve(this.$el);
	        this.observer.disconnect();
	        this.observer = null;
	    }
	}

	mounted() {
	    this.observe();
	}

	public destroyed() {
	    this.unObserve();
	}
}
